<template>
  <div class="container mt-4 informes">
    <div class="mb-3">
      <h2 class="mb-0"><i class="bi bi-pie-chart me-2"></i>Informes</h2>
      <small class="text-muted">Evolución FI + Cripto · también te llega por email el día 2 de cada mes</small>
    </div>

    <div v-if="cargando" class="text-center py-5"><span class="spinner-border"></span></div>
    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
    <template v-else-if="informe">
      <div class="row g-3 mb-3 text-center">
        <div v-for="k in kpis" :key="k.titulo" class="col-6 col-md">
          <div class="text-muted small">{{ k.titulo }}</div>
          <div class="fs-4" :class="k.clase">{{ k.valor }}</div>
        </div>
      </div>

      <div class="card mb-3"><div class="card-body">
        <h5 class="card-title text-center">EVOLUCIÓN últimos 180d FI + Cripto y Beneficio</h5>
        <div class="grafico"><Line :data="datos180" :options="opciones180" /></div>
      </div></div>

      <div class="card mb-3"><div class="card-body">
        <h5 class="card-title text-center">EVOLUCIÓN CRIPTO (Desde 2021)</h5>
        <div class="grafico"><Line :data="datosCripto" :options="opcionesSimple" /></div>
      </div></div>

      <div class="card mb-3"><div class="card-body">
        <h5 class="card-title text-center">EVOLUCIÓN DIARIA FI (histórico)</h5>
        <div class="grafico"><Line :data="datosHistorico" :options="opcionesSimple" /></div>
      </div></div>

      <div v-if="informe.gastos && informe.gastos.length" class="card mb-3"><div class="card-body">
        <h5 class="card-title text-center">GASTOS mensuales (desde 2021)</h5>
        <div class="grafico"><Bar :data="datosGastos" :options="opcionesSimple" /></div>
      </div></div>

      <div v-if="informe.fire && informe.fire.length" class="card mb-3"><div class="card-body">
        <h5 class="card-title text-center">% FIRE Generado y Retiro (desde 2021)</h5>
        <div class="grafico"><Line :data="datosFire" :options="opcionesFire" /></div>
        <p class="text-muted small text-center mb-0">
          Ganancia anual esperada ÷ gastos anuales (media de los últimos 12 meses × 12). Retiro: tasa {{ informe.tasaRetiro }}% sobre el patrimonio FI + cripto; Generado: misma base con la tasa de la hoja.
        </p>
      </div></div>
    </template>
  </div>
</template>

<script>
import axios from '../config/axios';
import { Line, Bar } from 'vue-chartjs';
import {
  Chart as ChartJS, CategoryScale, LinearScale, LineElement, PointElement, BarElement, LineController, BarController, Tooltip, Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, LineElement, PointElement, BarElement, LineController, BarController, Tooltip, Legend);

const euros = (n) => `${Number(n || 0).toLocaleString('es-ES', { maximumFractionDigits: 0 })} €`;
const miles = (v) => (Math.abs(v) >= 1000 ? `${Math.round(v / 1000)} mil` : v);
const linea = (label, data, color, extra = {}) => ({
  label, data, borderColor: color, backgroundColor: color, borderWidth: 2, pointRadius: 0, tension: 0.1, ...extra
});

export default {
  name: 'Informes',
  components: { Line, Bar },
  data() {
    return { informe: null, cargando: true, error: '' };
  },
  computed: {
    kpis() {
      const k = this.informe.kpis;
      return [
        { titulo: 'Total FI + Cripto', valor: euros(k.totalFiCripto) },
        { titulo: 'Importe total', valor: euros(k.importeTotal) },
        { titulo: 'Total FI', valor: euros(k.totalFi) },
        { titulo: 'Total propio FI', valor: euros(k.totalPropioFi) },
        { titulo: 'Cripto actual', valor: euros(k.criptoActual), clase: 'text-danger' },
        ...(k.pctFireGenerado == null ? [] : [{ titulo: '% FIRE Generado', valor: `${String(k.pctFireGenerado).replace('.', ',')} %`, clase: 'text-success' }]),
        ...(k.pctFireRetiro == null ? [] : [{ titulo: '% FIRE Retiro', valor: `${String(k.pctFireRetiro).replace('.', ',')} %`, clase: 'text-primary' }])
      ];
    },
    opcionesSimple() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'index', intersect: false },
        plugins: { tooltip: { callbacks: { label: (c) => `${c.dataset.label}: ${euros(c.parsed.y)}` } } },
        scales: {
          x: { ticks: { maxTicksLimit: 8, maxRotation: 0 } },
          y: { ticks: { callback: miles } }
        }
      };
    },
    opciones180() {
      const o = this.opcionesSimple;
      return {
        ...o,
        scales: {
          ...o.scales,
          y1: { position: 'right', grid: { drawOnChartArea: false }, ticks: { callback: miles } }
        }
      };
    },
    datos180() {
      const p = this.informe.ultimos180;
      return {
        labels: p.map((x) => x.fecha),
        datasets: [
          linea('Total', p.map((x) => x.total), '#111'),
          linea('Beneficio', p.map((x) => x.beneficio), '#e53935', { yAxisID: 'y1', borderDash: [6, 3] })
        ]
      };
    },
    opcionesFire() {
      const o = this.opcionesSimple;
      return {
        ...o,
        plugins: { tooltip: { callbacks: { label: (c) => `${c.dataset.label}: ${c.parsed.y} %` } } },
        scales: { ...o.scales, y: { ticks: { callback: (v) => `${v} %` } } }
      };
    },
    datosGastos() {
      const g = this.informe.gastos;
      return {
        labels: g.map((x) => x.mes),
        datasets: [
          { type: 'bar', label: 'Gasto mensual', data: g.map((x) => x.total), backgroundColor: '#b0bec5' },
          linea('Media 12 meses', g.map((x) => x.media12), '#e65100', { type: 'line' })
        ]
      };
    },
    datosFire() {
      const p = this.informe.fire;
      return {
        labels: p.map((x) => x.fecha),
        datasets: [
          linea('% FIRE Generado', p.map((x) => x.generado), '#198754'),
          linea('% FIRE Retiro', p.map((x) => x.retiro), '#6f42c1')
        ]
      };
    },
    datosCripto() {
      const p = this.informe.cripto;
      return { labels: p.map((x) => x.fecha), datasets: [linea('Cripto', p.map((x) => x.valor), '#1e40af')] };
    },
    datosHistorico() {
      const p = this.informe.historico;
      return {
        labels: p.map((x) => x.fecha),
        datasets: [
          linea('Importe total', p.map((x) => x.total), '#1e40af'),
          linea('Importe propio', p.map((x) => x.propio), '#f4511e')
        ]
      };
    }
  },
  async mounted() {
    try {
      const { data } = await axios.get('/api/informes/fi-cripto');
      this.informe = data;
    } catch (e) {
      this.error = (e.response && e.response.data && e.response.data.error) || 'No se pudo cargar el informe';
    } finally {
      this.cargando = false;
    }
  }
};
</script>

<style scoped>
.grafico { position: relative; height: 340px; }
</style>
